// Persönliche Akzentfarbe (Personalisierung im Profil-Menü). Exakt das theme.ts-Muster: das Modul kennt
// nur den Zustand (lesen / anwenden / persistieren / abonnieren), die WERTE leben in design/accents.css.
// Orange ist der Standard (kein data-accent-Attribut = die --accent-Defaults aus tokens.css); jede andere
// Wahl setzt data-accent auf <html>, worauf accents.css die Akzent-Tokens umdefiniert.
//
// Bewusst NUR am Gerät gespeichert (localStorage 'wf_accent', wie 'wf_theme') — kein Backend-Feld,
// solange das Feature jung ist. Wandert die Farbe später ans Konto, bleibt dieses Modul die eine Stelle.

export type Accent = 'orange' | 'blau' | 'gruen' | 'violett'

export const ACCENT_OPTIONS: ReadonlyArray<{ id: Accent; label: string }> = [
  { id: 'orange', label: 'Orange' },
  { id: 'blau', label: 'Blau' },
  { id: 'gruen', label: 'Grün' },
  { id: 'violett', label: 'Violett' },
]

const STORAGE_KEY = 'wf_accent'
const listeners = new Set<() => void>()

function isAccent(value: unknown): value is Accent {
  return value === 'orange' || value === 'blau' || value === 'gruen' || value === 'violett'
}

function readStored(): Accent {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return isAccent(raw) ? raw : 'orange'
  } catch {
    return 'orange' // localStorage gesperrt: still auf den Standard zurückfallen, nie werfen.
  }
}

function applyToDocument(accent: Accent): void {
  const root = document.documentElement
  if (accent === 'orange') root.removeAttribute('data-accent') // Standard = tokens.css-Defaults
  else root.setAttribute('data-accent', accent)
}

let current: Accent = readStored()

/** Beim Boot aufrufen (vor dem Render): gespeicherte Akzentfarbe auf <html> anwenden. */
export function initAccent(): void {
  current = readStored()
  applyToDocument(current)
}

export function getAccent(): Accent {
  return current
}

export function setAccent(accent: Accent): void {
  current = accent
  applyToDocument(accent)
  try {
    localStorage.setItem(STORAGE_KEY, accent)
  } catch {
    // Persistenz nicht verfügbar — die Farbe gilt dann nur für diese Sitzung. Kein Absturz.
  }
  for (const listener of listeners) listener()
}

/** Abonnement für React (useSyncExternalStore). Gibt die Abmeldefunktion zurück. */
export function subscribeAccent(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
